(function ($) {
    collapseAllFloatingItems();

    $('.nav-item.dropdown').click(function () {
        var width = $(document).width();
        if (width >= 991) {
            //for dynamic floatingNavbar 
            var valtoassign = $(this).children(".nav-link.dropdown-toggle").attr("data-floatingnav");
            if (valtoassign) {
                if (!($("#floatnavbar button").hasClass("collapsed"))) {
                    $("#floatnavbar button").click();
                }
                $("#floatnavbar button").attr("data-bs-target", '#' + valtoassign);
            }
        }
    });

    $(document).ready(function () {
        $(".nav-link.dropdown-toggle").each(function () {
            var el = $(this).attr("data-floatingnav");

            if (el) {
                var width = $(document).width();
                if (width < 991) {
                    var id = $(this).attr("id");
                    var targetNode = document.getElementById(id);
                    // Options for the observer (which mutations to observe)
                    var config = { attributes: true };
                    // Callback function to execute when mutations are observed
                    var callback =function (mutationList, observer){
                        mutationList.forEach(function (mutation){
                            if (mutation.type === "attributes") {
                                var attr = $(targetNode).attr("aria-expanded");
                                if (attr == "true") {
                                    var valtoassign = $(targetNode).attr("data-floatingnav");
                                    if (valtoassign) {
                                        if (!($("#floatnavbar button").hasClass("collapsed"))) {
                                            $("#floatnavbar button").click();
                                        }
                                        $("#floatnavbar button").attr("data-bs-target", '#' + valtoassign);
                                    }
                                }
                            }
                        });
                    };

                    // Create an observer instance linked to the callback function
                    var observer = new MutationObserver(callback);
                    // Start observing the target node for configured mutations
                    observer.observe(targetNode, config);
                }
            }
        });
    });
}(window.jQuery));

function collapseAllFloatingItems() {

    if ($(".collapseAllFloatingItems").length) {

        $("#floatnavbar").on("click", ".btn:not(.collapsed)", function () {
            var listInSemiExpanded = $("#floatnavbtn_semimaximized li");

            for (var i = 0; i < listInSemiExpanded.length; i++) {
                if ($("ul#floatnavbtn").length) {
                    $("ul#floatnavbtn").append(listInSemiExpanded[i]);
                }
            }

            $("ul#floatnavbtn_semimaximized").empty().remove();
            window.sessionStorage.setItem("floatexpand", ".btn.collapsed");

            $("#floatnavbar").removeClass("d-none");
        });

        $("#floatnavbar").on("click", ".btn.collapsed", function () {
            window.sessionStorage.setItem("floatexpand", ".btn");
        });

        var floatexpand = window.sessionStorage.getItem("floatexpand");

        if (floatexpand == ".btn") {
            var listInSemiExpanded = $("#floatnavbtn_semimaximized li");

            for (var i = 0; i < listInSemiExpanded.length; i++) {
                if ($("ul#floatnavbtn").length) {
                    $("ul#floatnavbtn").append(listInSemiExpanded[i]);
                }
            }

            $("ul#floatnavbtn_semimaximized").empty().remove();
            $("#floatnavbar").removeClass("d-none");
            $("#floatnavbar").find(".btn").trigger("click");

            setTimeout(function () {
                window.sessionStorage.setItem("floatexpand", ".btn");
            }, 1000);
        }
        else if (floatexpand == ".btn.collapsed") {
            $("#floatnavbar").find(".btn.collapsed").trigger("click");
            $("#floatnavbar").removeClass("d-none");
        }
        else {
            $("#floatnavbar").removeClass("d-none");
        }
    }
    else {
        if ($("#floatnavbar").length) {
            $("#floatnavbar").on("click", ".btn.collapsed", function () {
                window.sessionStorage.setItem("floatexpand", ".btn");
            });

            $("#floatnavbar").on("click", ".btn:not(.collapsed)", function () {
                window.sessionStorage.setItem("floatexpand", ".btn.collapsed");
            });

            var floatexpand2 = window.sessionStorage.getItem("floatexpand");

            if (floatexpand2 == ".btn") {
                $("#floatnavbar").removeClass("d-none");
                $("#floatnavbar .btn:not(.collapsed)").click();
            }
            else if (floatexpand2 == ".btn.collapsed") {
                $("#floatnavbar").find(".btn.collapsed").trigger("click");
                $("#floatnavbar").removeClass("d-none");
            }

            $("#floatnavbar").removeClass("d-none");
        }
    }
}

// Analytics for FloatingNavBar/Index.cshtml
analytics.eventConfig.push({
    "target": "#floatnavbar",
    "codeId": "fb",
    "events": [
        {
            "eventTarget": "a:not([href*=\\http])",
            "eventType": "click",
            "tags": {
                "event": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "contact"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "componentName": "floating bar",
                "componentId": "fb",
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "click to email"
                    },
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "other media asset click"
                    },
                    {
                        "rule": "true",
                        "value": "floating bar internal navigation click"
                    }
                ],
                "elementType": "floating bar link",
                "elementText": "",
                "destinationUrl": "",
                "titleText": "",
                "listOrdinal": {
                    "ref": "ul",
                    "ele": "li"
                }
            }
        },
        {
            "eventTarget": "a[href*=\\http]",
            "eventType": "click",
            "tags": {
                "event": [
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "outbound"
                    }
                ],
                "componentName": "floating bar",
                "componentId": "fb",
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1",
                        "value": "pds download click"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                        "value": "sds download click"
                    },
                    {
                        "rule": "true",
                        "value": "outbound click"
                    }
                ],
                "elementType": "floating bar link",
                "elementText": "",
                "destinationUrl": "",
                "fileName": "",
                "titleText": "",
                "listOrdinal": {
                    "ref": "ul",
                    "ele": "li"
                }
            }
        },
        {
            "eventTarget": "button",
            "eventType": "click",
            "tags": {
                "componentId": "fb",
                "componentName": "floating bar",
                "elementType": "floating bar arrow",
                "event": "navigation",
                "eventType":
                    [
                        {
                            "rule": "$(context).hasClass('collapsed')",
                            "value": "floating bar collapse click"
                        },
                        {
                            "rule": "true",
                            "value": "floating bar expansion click"
                        }
                    ]
            }
        }
    ]
});